import { render, staticRenderFns } from "./Tscore.vue?vue&type=template&id=36d3efab&scoped=true"
import script from "./Tscore.vue?vue&type=script&lang=js"
export * from "./Tscore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d3efab",
  null
  
)

export default component.exports